import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import InputFieldText from "Components/Common/InputFieldText";
import SelectField from "Components/Common/SelectField";
import { CONSUMER } from "common/constant";
import { getOptionValue, gstOptions } from "common/enums";

import { useConsumersQuery } from "apis/User";
import { useApplicantTypeQuery } from "apis/ApplicantType";

const BackupPowerDetail = ({ formik, t }) => {
  const { roles } = useSelector((state) => state.Login);

  const { data: { data: { items: applicantType } = {} } = {} } =
    useApplicantTypeQuery();

  const {
    values: {
      // extraValues: { premiseType },
      applicationTypeId,
      applicant: { applicantTypeId, isGSTRegistered },
      extraValues: { isPanNumber, isGstNumber },
      id,
      consumerNumber,
      inProgressApplicationId,
      isAllApplicationsProcessCompleted,
      payableBillAmount,
    },
    setFieldValue,
  } = formik;

  const { data: { data: consumersOption } = {} } = useConsumersQuery({
    applicationType: applicationTypeId,
    utilityId: getOptionValue("utilityOptions", "Power"),
  });

  const isIndividualApplicantType = useMemo(
    () =>
      applicantType?.find(
        (application) => application.name.toLowerCase() === "individual"
      ).id === applicantTypeId,
    [applicantType, applicantTypeId]
  );

  const isDisable = useMemo(
    () =>
      (inProgressApplicationId !== id && !isAllApplicationsProcessCompleted) ||
      payableBillAmount > 0,
    [
      inProgressApplicationId,
      id,
      isAllApplicationsProcessCompleted,
      payableBillAmount,
    ]
  );
  return (
    <>
      {roles.includes(CONSUMER) && (
        <Row>
          <Col md={4} sm={6}>
            <SelectField
              label={t("Customer Number") + "*"}
              name="utilityConsumerId"
              formik={formik}
              options={consumersOption || []}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.consumerNumber}
            />
          </Col>
        </Row>
      )}
      <Typography className="mb-3" lineHeight="1" variant="h6">
        {t("Customer Details")}:
      </Typography>
      <Row>
        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Customer Name")}
            name="extraValues.consumerName"
            formik={formik}
            disabled
          />
        </Col>

        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Current Tariff Category")}
            name="extraValues.tariffName"
            formik={formik}
            disabled
          />
        </Col>

        <Col md={4} sm={6}>
          <InputFieldText
            label={t("Premise Usage Purpose")}
            name="extraValues.premiseUsagePurpose"
            formik={formik}
            placeholder="Enter Premise Usage Purpose"
            disabled
          />
        </Col>
        {!isPanNumber && (
          <Col md={4} sm={6}>
            <InputFieldText
              label={
                isIndividualApplicantType
                  ? t("PAN Number")
                  : t("PAN Number") + "*"
              }
              name="applicant.panNumber"
              formik={formik}
              disabled={isDisable}
              onChange={(e) =>
                setFieldValue(
                  "applicant.panNumber",
                  e.target.value.toUpperCase()
                )
              }
              placeholder={
                isIndividualApplicantType
                  ? t("PAN Number")
                  : t("PAN Number") + "*"
              }
            />
          </Col>
        )}
        {!isGstNumber && (
          <Col md={4} sm={6}>
            <SelectField
              label={t("GST") + "*"}
              name="applicant.isGSTRegistered"
              onChange={(_, { value }) => {
                setFieldValue("applicant.isGSTRegistered", value);
                if (!value) {
                  setFieldValue("applicant.gstNumber", "");
                }
              }}
              formik={formik}
              disabled={isDisable}
              options={gstOptions}
            />
          </Col>
        )}
        {!isGstNumber && isGSTRegistered && (
          <Col md={4} sm={6}>
            <InputFieldText
              label={t("GST Number") + "*"}
              name="applicant.gstNumber"
              formik={formik}
              onChange={(e) =>
                setFieldValue(
                  "applicant.gstNumber",
                  e.target.value.toUpperCase()
                )
              }
              placeholder="GST Number"
              disabled={isDisable}
            />
          </Col>
        )}
        {/* <Col md={4} sm={6}>
          <InputFieldText
            label={t("Premise Type")}
            name="extraValues.premiseType"
            formik={formik}
            placeholder="Enter Premise Type"
            disabled
          />
        </Col> */}
      </Row>
      {/* {premiseType?.toLowerCase() === "residential" && (
        <Typography variant="subtitle2" color="error">
          {t("Backup power is not applicable for residential premise type")}
        </Typography>
      )} */}
      {!!inProgressApplicationId &&
      inProgressApplicationId !== id &&
      !isAllApplicationsProcessCompleted &&
      !!consumerNumber ? (
        <Typography variant="body2" color="error">
          {t(
            "There are some incomplete applications associated with this consumer number. You are unable to fill the form."
          )}
        </Typography>
      ) : payableBillAmount > 0 ? (
        <Typography variant="body2" color="error">
          You have an unpaid amount of {payableBillAmount} RS. Please pay first
          to continue.
        </Typography>
      ) : null}
    </>
  );
};
BackupPowerDetail.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
};
export default withTranslation()(BackupPowerDetail);
